import { render, staticRenderFns } from "./OptionSettingsModal.vue?vue&type=template&id=9497cc80"
import script from "./OptionSettingsModal.vue?vue&type=script&lang=js"
export * from "./OptionSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./OptionSettingsModal.vue?vue&type=style&index=0&id=9497cc80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports